import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  API_URL
} from '../../../../constants'

import { getOccurenceFiles } from '../../../../actions/mypage'
import { getOccurrenceAssigns } from '../../../../actions/tasks'

// Utils
import { translation } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'

// Components
import Comments from './Comments'
import Files from './Files'
import Gallery from '../../../../shared/components/Gallery'
import { hasSubscriptionPermission } from '../../../../utils/auth'

import './index.scss'

// Elements
import Panel from '../../../../shared/elements/panel'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Col from '../../../../shared/elements/col'
// import { ElementIcons } from '../../../../shared/elements/icons'
// import Icon from '../../../../shared/elements/icon'
import Divider from '../../../../shared/elements/divider'
import Image from '../../../../shared/elements/image'

class MyTasksTask extends Component {
  constructor (props) {
    super(props)
    this.state = {
      task: {},
      scrollOffset: 0
    }
  }

  componentDidMount () {
    this.updateTaskFromProps(this.props.item)

    if (this.props.modal === true) {
      this.setScroll(false)
    }

    setTimeout(() => {
      var backdrop = document.getElementsByClassName('backdrop')[0]
      if (backdrop) {
        backdrop.style = 'display: none;'
      }
      backdrop = document.getElementsByClassName('updating--state')[0]
      if (backdrop) {
        backdrop.style = 'display: none;'
      }
    }, 100)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.item && nextProps.item.OccurrenceId !== this.props.item.OccurrenceId) {
      this.updateTaskFromProps(nextProps.item)
    }

    if (nextProps.modal === true && this.props.modal === false) {
      this.setScroll(false)
    }
  }

  componentWillUnmount () {
    this.setScroll(true)

    var backdrop = document.getElementsByClassName('backdrop')[0]
    if (backdrop) {
      backdrop.style = undefined
    }

    backdrop = document.getElementsByClassName('updating--state')[0]
    if (backdrop) {
      backdrop.style = undefined
    }
  }

  updateTaskFromProps (task) {
    this.setState({
      task: {
        ...task,
        Assigns: []
      }
    })
    this.getFiles(task.OccurrenceId)
    this.getAssigns(task.OccurrenceId)
  }

  getAssigns (id) {
    this.props.getOccurrenceAssigns(id).then(res => {
      this.setState({
        task: {
          ...this.state.task,
          Assigns: res.data
        }
      })
    })
  }

  setScroll (show) {
    let app = document.getElementById('app')
    if (show) {
      app.style = null
      app.scrollTop = this.state.scrollOffset
    } else if (show === false) {
      this.setState({
        scrollOffset: app.scrollTop
      }, () => {
        app.scrollTop = 0
        app.style.overflow = 'hidden'
      })
    }
  }

  getFiles (id) {
    this.props.getOccurenceFiles(id).then((res) => {
      this.setState({
        task: {
          ...this.state.task,
          Files: res.data
        }
      })
    })
  }

  renderAttachments (files) {
    if (!Array.isArray(files) || files.length === 0) return null

    let imgFiles = []
    let otherFiles = []
    files.forEach(file =>
      file.IsImage
      ? imgFiles.push(file)
      : otherFiles.push(file)
    )

    const renderFile = (file, index) => {
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileName
      return (
        <li key={index} className='file-document'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          <a target='_BLANK' href={file.FileURL}>
            {file.FileName}
          </a>
        </li>
      )
    }
    // Render image
    const renderImage = (image, key) => {
      return (
        <Image key={key} imageFile={image} />
      )
    }

    return (
      <div>
        <Divider />
        <LabelWrapper labelText={translation('352')}>
          {otherFiles.length !== 0 && (
            <div className='docs'>
              <ul>
                {otherFiles.map(renderFile)}
              </ul>
            </div>
          )}
          {imgFiles.length !== 0 && <Gallery files={imgFiles} renderImage={renderImage} />}
        </LabelWrapper>
      </div>
    )
  }

  content (task) {
    let spans = window.innerWidth <= 930 ? '1' : '2'

    return (
      <div className='myTasksTask__screen'>
        <Col span={spans}>
          <Panel title={translation(task.Category)}>
            <LabelWrapper labelText={translation('1021')}>
              {translation(task.Category)}
            </LabelWrapper>
            {task.Description.split('\n').map((line, key) => {
              return (
                <span key={key}>
                  {line}<br />
                </span>
              )
            })}
            <LabelWrapper labelText={translation('15086')}>
              {task.Assigns.map((x, key) => { return <div key={key}>{x}</div> })}
            </LabelWrapper>
            {window.innerWidth <= 760 && (<LabelWrapper labelText={translation(1232)}>
              <div className='deadline-date'>{renderFullDate(task.Deadline, false)}</div>
            </LabelWrapper>)}
            {task.Files && this.renderAttachments(task.Files.OtherTaskFiles)}
          </Panel>
        </Col>
        <Col span={spans}>
          <Files OccurrenceId={task.OccurrenceId} files={task.Files ? task.Files.OtherTaskOccurrenceFiles : []} />
        </Col>
        <Col span={spans}>
          <Comments OccurrenceId={task.OccurrenceId} />
        </Col>
      </div>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    let { task } = this.state
    if (typeof task === 'undefined') return null
    if (Object.keys(task).length === 0) return null

    // const makeTime = () => {
    //   return renderFullDate(task.Deadline, false)
    // }
    // let labelText = (
    //   <Grid cols={[1, 'max-content']}>
    //     {task.Title}
    //   </Grid>
    // )
    // let deadlineText = (
    //   <Grid cols={[1, 'max-content']}>
    //     {translation('1232')}
    //   </Grid>
    // )

    // if (this.props.modal !== true) {
    //   return this.content(task)
    // }

    return this.content(task)

    /*
    return (
      <div className='myTaskOverlay' data-modal='true'>
        <Panel>
          <Grid cols={[1, 1, 1]} spacing={1} align='center'>
            <LabelWrapper labelText={labelText}>
              {translation(task.Category)}
            </LabelWrapper>
            <LabelWrapper labelText={deadlineText}>
              {makeTime()}
            </LabelWrapper>
            <div className='closeButton'>
              <CloseButton size='l' onClick={this.props.onClose} />
            </div>
          </Grid>
        </Panel>
        <div className='content'>
          {this.content(task)}
        </div>
      </div>
    )
    */
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getOccurenceFiles,
  getOccurrenceAssigns
})(MyTasksTask)



// WEBPACK FOOTER //
// ./src/app/pages/MyPage/MyTasks/Task/index.js